import { TIME_MASK_ZEROHOUR_ZEROMINUTES } from "../Forms/Constants/TimeConstants";

export interface CountryHandlingTime {
  CountryId: number;
  HandlingTime: string;
  CountryName: string;
}

export const defaultCountryHandlingTime = {
  CountryId: 0,
  HandlingTime: TIME_MASK_ZEROHOUR_ZEROMINUTES,
  CountryName: "",
};
